import { endSession } from '@lib/auth/session';
import { useNavigate } from 'react-router-dom';

const useLogout = () => {
  const navigate = useNavigate();

  const logout = () => {
    endSession();
    navigate('/login');
  };

  return logout;
};

export default useLogout;
